import * as Sentry from "@sentry/browser";
const sentry = (tracker) => {
    if (typeof window !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.Sentry) {
            tracker(Sentry);
        }
    }
};
export { sentry };
//# sourceMappingURL=sentry.js.map